<template>
  <div class="box">
    <div class="header2">
      <img :src="row.user.face" alt="" />
      <div class="header_right">
        <h1>{{ row.user.name }}</h1>
        <h2>
          加入啦啦操大家庭<font
            style="
              margin-left: 0.12rem;
              margin-right: 0.12rem;
              font-size: 0.34rem;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #191919;
              line-height: 0.48rem;
            "
            >{{ row.days }}</font
          >天
        </h2>
        <div class="invite-level">
          <div v-if="userDetail.stars.caipan > 0" class="level_info">
            <img
              class="title-icon"
              src="../../../../assets/images/font-cai@2x.png"
              alt=""
              style="width: 0.25rem; height: 0.25rem"
            />
            <img
              v-if="userDetail.stars.caipan == 1"
              src="../../../../assets/images/icon-star1@2x.png"
              alt=""
            />
            <img
              v-if="userDetail.stars.caipan == 2"
              src="../../../../assets/images/icon-star2@2x.png"
              alt=""
            />
            <img
              v-if="userDetail.stars.caipan == 3"
              src="../../../../assets/images/icon-star3@2x.png"
              alt=""
            />
            <img
              v-if="userDetail.stars.caipan == 4"
              src="../../../../assets/images/icon-star4@2x.png"
              alt=""
            />
            <img
              v-if="userDetail.stars.caipan == 5"
              src="../../../../assets/images/icon-star5@2x.png"
              alt=""
            />
          </div>
          <div v-if="userDetail.stars.yundongyuan > 0" class="level_info">
            <img
              class="title-icon"
              src="../../../../assets/images/font-yun@2x.png"
              alt=""
              style="width: 0.25rem; height: 0.25rem"
            />
            <img
              v-if="userDetail.stars.yundongyuan == 1"
              src="../../../../assets/images/icon-star1@2x.png"
              alt=""
            />
            <img
              v-if="userDetail.stars.yundongyuan == 2"
              src="../../../../assets/images/icon-star2@2x.png"
              alt=""
            />
            <img
              v-if="userDetail.stars.yundongyuan == 3"
              src="../../../../assets/images/icon-star3@2x.png"
              alt=""
            />
            <img
              v-if="userDetail.stars.yundongyuan == 4"
              src="../../../../assets/images/icon-star4@2x.png"
              alt=""
            />
            <img
              v-if="userDetail.stars.yundongyuan == 5"
              src="../../../../assets/images/icon-star5@2x.png"
              alt=""
            />
          </div>
          <div v-if="userDetail.stars.jiaolian > 0" class="level_info">
            <img
              class="title-icon"
              src="../../../../assets/images/font-jiao@2x.png"
              alt=""
              style="width: 0.25rem; height: 0.25rem"
            />
            <img
              v-if="userDetail.stars.jiaolian == 1"
              src="../../../../assets/images/icon-star1@2x.png"
              alt=""
            />
            <img
              v-if="userDetail.stars.jiaolian == 2"
              src="../../../../assets/images/icon-star2@2x.png"
              alt=""
            />
            <img
              v-if="userDetail.stars.jiaolian == 3"
              src="../../../../assets/images/icon-star3@2x.png"
              alt=""
            />
            <img
              v-if="userDetail.stars.jiaolian == 4"
              src="../../../../assets/images/icon-star4@2x.png"
              alt=""
            />
            <img
              v-if="userDetail.stars.jiaolian == 5"
              src="../../../../assets/images/icon-star5@2x.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
    <div class="content" style="margin-top: 0.68rem">
      <div class="sai_list">
        <div class="list_title" v-rblink="{name:'ISaiApplyList'}">
          <h1>我报名的比赛</h1>
          <h2>以备案单位为主题发起报名参加的啦啦操比赛 <br />管理证书下载</h2>
        </div>
        <div v-for="(item, index) in row.sai_list" :key="index">
          <div class="br"></div>
          <div class="list_header">
            <h1>{{ item.saiqu_name }}</h1>
            <div class="action_btn" v-rblink="{name:'ISaiApplyList'}">继续操作</div>
          </div>
        </div>
        <div class="br"></div>
        <div class="list_title" v-rblink="{name:'ChaIndex'}">
          <h1>教练员裁判员优秀证书下载</h1>
          <h2>教练员裁判员优秀证书下载</h2>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="sai_list">
        <div class="list_title" v-rblink="{name:'HuiyiApplyList'}">
          <h1>我的会议培训</h1>
          <h2>我报名的啦啦操的会议培训</h2>
        </div>
        <div v-for="(item, index) in row.huiyi_list" :key="index">
          <div class="br"></div>
          <div class="list_header">
            <h1>{{ item.station_name }}</h1>
            <div class="action_btn" v-rblink="{name:'HuiyiApplyList'}">继续操作</div>
          </div>
        </div>
      </div>
    </div>
    <div class="content" v-if="row.kaoji_list.length>0">
      <div class="sai_list">
        <div class="list_title">
          <h1>我的考级</h1>
          <h2>我报名的考级</h2>
        </div>
        <div v-for="(item, index) in row.kaoji_list" :key="index">
          <div class="br"></div>
          <div class="list_header">
            <h1>{{ item.type_name }}</h1>
            <div class="action_btn">继续操作</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.box {
  height: 100%;
  overflow: scroll;
  padding-bottom: 1rem;
  background: #f0eff4;
}
.header2 {
  padding-top: 0.6rem;
  padding-left: 0.3rem;
  display: flex;
  background: linear-gradient(180deg, #ffffff 0%, #f0eff4 100%);
  box-shadow: 0px 1px 3px 0px rgba(237, 236, 241, 1);
}
.header2 img {
  display: block;
  width: 1.68rem;
  height: 1.68rem;
  border-radius: 1.6rem;
}
.header_right {
  margin-left: 0.3rem;
  display: flex;
  flex-direction: column;
}
.header_right h1 {
  font-size: 0.42rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #191919;
  line-height: 0.6rem;
}
.header_right h2 {
  font-size: 0.26rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 0.38rem;
  margin-top: 0.12rem;
}
.content {
  margin-top: 0.2rem;
  padding: 0 0.2rem;
}
.content_title {
  display: flex;
}
.content_title h1 {
  font-size: 0.42rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  line-height: 0.6rem;
}
.content_title img {
  width: 1.52rem;
  height: 0.18rem;
  margin-top: 0.22rem;
  margin-left: 0.3rem;
}

.sai_list {
  background: #ffffff;
  border-radius: 10px;
  padding-top: 0.1rem;
  margin-top: 0.32rem;
  padding-bottom: 0.3rem;
}
.list_header {
  display: flex;
  justify-content: space-between;
  margin-top: 0.3rem;
}
.list_header h1 {
  font-size: 0.28rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #000000;
  line-height: 0.4rem;
  margin-left: 0.3rem;
  line-height: 28px;
}
.list_header img {
  width: 1.32rem;
  height: 0.42rem;
}
.br {
  height: 1px;
  background-color: rgba(0, 0, 0, 0.1);
  margin-top: 0.3rem;
}
.action_btn {
  width: 1.36rem;
  height: 0.56rem;
  background: linear-gradient(316deg, #f8d77f 0%, #fcab15 100%);
  border-radius: 0.46rem;
  font-size: 0.24rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 0.56rem;
  text-align: center;
  margin-right: 0.3rem;
}
.list_title {
  padding: 0.3rem;
  padding-bottom: 0;
}
.list_title h1 {
  font-size: 0.3rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #000000;
  line-height: 0.42rem;
}
.list_title h2 {
  font-size: 0.28rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 0.4rem;
  margin-top: 0.2rem;
}
.invite-level {
  display: flex;
}

.level_info {
  width: 0.99rem;
  height: 0.41rem;
  background: #ffffff;
  border-radius: 0.21rem;
  margin-right: 0.12rem;
  display: flex;
  justify-content: space-between;
}

.level_info img {
  width: 0.34rem;
  height: 0.34rem;
  margin-top: 0.035rem;
  margin-right: 0.1rem;
}

.title-icon {
  line-height: 0.41rem;
  margin-left: 0.1rem;
  padding-top: 0.06rem;
}
</style>
<script>
import Vue from "vue";
// import area from "../../../utils/area";
// import validator from "../../../utils/validator";
import PicUploader from "@/components/picker/PicUploader.vue";
import LoginDialog from "@/components/LoginDialog.vue";

import {
  Cell,
  Field,
  Area,
  Form,
  Divider,
  CellGroup,
  RadioGroup,
  Radio,
  Icon,
  Toast,
  Popup,
  Picker,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Switch,
  Button,
} from "vant";

Vue.use(Cell)
  .use(CellGroup)
  .use(Form)
  .use(Divider)
  .use(Area)
  .use(RadioGroup)
  .use(Radio)
  .use(Icon)
  .use(Toast)
  .use(Popup)
  .use(Picker)
  .use(Sidebar)
  .use(SidebarItem)
  .use(Tag)
  .use(Stepper)
  .use(Field)
  .use(Switch)
  .use(Button);
export default {
  name: "MyActivity",
  components: {
    PicUploader,
    LoginDialog,
  },
  data: function () {
    return {
      loading: true,
      saveLoading: false,
      loginShow: false,
      showArea: false,
      areaList: {},
      areaValue: "",
      submitType: "",
       userDetail: {},
      row: {
        danwei: {},
        cert: {},
        kaoji_list:[],
      },
      formData: {},
      max1: 2,
      max2: 2,
      max3: 2,
      max1show: true,
      max2show: true,
      max3show: true,
    };
  },
  filters: {},
  mounted() {
    document.title = "我的活动";
    let that = this;
    this.fetch();
    this.getInfo()
  },
  watch: {},
  destroyed() {},
  methods: {
    onQuestion() {
      console.log("onQuestion");
    },

    toJiaolian() {
      if (this.row.cert.status) {
        rbLink({
          name: "UserSearchJiaolian",
        });
      } else {
        Toast("请先进行实名认证");
        setTimeout(function () {
          rbLink({
            name: "CertIndex",
          });
        }, 200);
      }
    },
    max1change() {
      this.max1 = 10000;
      this.max1show = false;
    },
    max2change() {
      this.max2 = 10000;
      this.max2show = false;
    },
    max3change() {
      this.max3 = 10000;
      this.max3show = false;
    },

    toCaipan() {
      if (this.row.cert.status) {
        rbLink({
          name: "UserSearchCaipan",
        });
      } else {
        Toast("请先进行实名认证");
        setTimeout(function () {
          rbLink({
            name: "CertIndex",
          });
        }, 200);
      }
    },
     getInfo() {
      let that = this;
      that.$api.get("/api/user/userPage", {}, (res) => {
        that.userDetail = res.data;
      });
    },
    fetch() {
      let that = this;
      that.$api.get(
        "/api/user/myapply",
        {},
        (res) => {
          that.row = res.data;
          that.loading = false;
        },
        (res) => {
          that.loading = false;
          if (res.code == 401 || res.code == 402) {
            if (window.isApp()) {
              rbLink(
                {
                  name: "login",
                  query: {},
                },
                "replace"
              );
              return false;
            }
            that.loginShow = true;
          } else {
            Toast(res.msg);
          }
        }
      );
    },
    loginSuccess(res) {
      console.log("-------登录成功--------", res);
      this.loginShow = false;
      this.fetch();
    },

    loginCancel() {
      console.log("-------取消登录--------");
      // this.loginShow = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// Activity.vue?33abad1a